import { EventPlace, trackEngagement } from "helpers/analytics";

import { EmailSettingsSubsection } from "./routes";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackEmailAddressesEvent = (event: string, data?: Record<string, unknown>) =>
  trackEngagement(`Email addresses: ${event}`, EventPlace.Settings, data);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackReplyAddressesEvent = (event: string, data?: Record<string, unknown>) =>
  trackEngagement(`Reply addresses: ${event}`, EventPlace.Settings, data);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackDomainsEvent = (event: string, data?: Record<string, unknown>) =>
  trackEngagement(`Domains: ${event}`, EventPlace.Settings, data);

export const trackEmailSectionOpened = (subsection: EmailSettingsSubsection): void =>
  trackEngagement(`Settings: Email address section opened`, EventPlace.Settings, { subsection });

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackContactAdminsClicked = (subsection: EmailSettingsSubsection) => {
  switch (subsection) {
    case EmailSettingsSubsection.ForwardingAddresses:
      return trackEmailAddressesEvent("Contact admins clicked");
    case EmailSettingsSubsection.ReplyAddresses:
      return trackReplyAddressesEvent("Contact admins clicked");
    case EmailSettingsSubsection.Domains:
      return trackDomainsEvent("Contact admins clicked");
  }
};
